export default __webpack_public_path__ + "static/media/BGSF_logo_800x271 (1).6488a2d0.jpg";